<div class="footer container-fluid">
    <div class="row text-center footer-content">
        <div *ngIf="appName==='lexus'" class="col-sm-12 align-self-center">
            <div class=" col-sm-12 align-self-center">
                <span *ngFor="let link of lexusPrivacyLink;let i = index">
                    <a [href]="link.privacyLinkUrl" target="_blank">{{link.privacyLinkName}}</a>
                    <span class="btn-img" aria-hidden="true" *ngIf="link.privacyLinkName === 'YOUR PRIVACY CHOICES'">
                        <img src="/assets/images/common/privacyCheckmark.png" alt="YOUR PRIVACY CHOICES" role="presentation">
                    </span>
                    {{i === lexusPrivacyLink.length - 1 ? '' : ' | '}}
                </span>
            </div>
            <div class="mt-2 col-sm-12 align-self-center privacyPolicy">
                {{ "Label.footer_lexus_content" | translate}}
            </div>
        </div>
        <div *ngIf="appName==='toyota'" class="col-sm-12 align-self-center">
            <div class=" col-sm-12 align-self-center">
                <span *ngFor="let link of toyotaPrivacyLink;let i = index">
                    <a [href]="link.privacyLinkUrl" target="_blank">{{link.privacyLinkName}}</a>
                    <span class="btn-img" aria-hidden="true" *ngIf="link.privacyLinkName === 'YOUR PRIVACY CHOICES'">
                        <img src="/assets/images/common/privacyCheckmark.png" alt="YOUR PRIVACY CHOICES" role="presentation">
                    </span>
                    {{i === toyotaPrivacyLink.length - 1 ? '' : ' | '}}
                </span>
            </div>
            <div class="mt-2 col-sm-12 align-self-center privacyPolicy">
                {{ "Label.footer_toyota_content" | translate}}
            </div>
        </div>
    </div>
</div>